import { IdName } from 'src/app/shared/models/id-name';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { environment } from 'src/environments/environment';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { IPax } from '../models/pax.model';

@Injectable({
  providedIn: 'root',
})
export class PaxApiService {
  headers = { 'content-type': 'application/json' };

  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/paxes`;
  }

  constructor(private http: HttpClient) {}

  getPaxes(currentFilter?: MainTableFilterModel): Observable<ApiResponse<IPax[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IPax[]>>(this.url, { params });
  }

  getAllPaxes(): Observable<IdName[]> {
    const url = `${this.url}/List`;
    return this.http.get<IdName[]>(url);
  }

  getPaxById(paxId: string): Observable<IPax> {
    const url = `${this.url}/${paxId}`;
    return this.http.get<IPax>(url);
  }

  createPax(pax: IPax): Observable<IPax> {
    return this.http.post<IPax>(this.url, pax, { headers: this.headers });
  }

  updatePax(update: IPax): Observable<IPax> {
    const url = `${this.url}/${update.id}`;
    return this.http.put<IPax>(url, update, { headers: this.headers });
  }

  deletePax(id: string) {
    const url = `${this.url}/${id}`;
    return this.http.delete<IPax>(url);
  }
}
